import _ from 'lodash'
import type {CssValue} from '../../constants'
import {deserializeUnit, serializeUnit} from '../utils/unit'
import type {Point} from '@wix/document-services-types'

const FOCAL_POINT_UNIT_TYPE = '%'
const VALID_UNIT_TYPES_SET = new Set([FOCAL_POINT_UNIT_TYPE])

const serializeFocalPointUnitValue = (value: number): CssValue | undefined =>
    serializeUnit({value, type: FOCAL_POINT_UNIT_TYPE}, VALID_UNIT_TYPES_SET)

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {x, y} = val

    if (!_.isNumber(x) || !_.isNumber(y)) {
        return undefined
    }

    return `${serializeFocalPointUnitValue(x)} ${serializeFocalPointUnitValue(y)}`
}

const deserialize = (rule: CssValue): Point | undefined => {
    const splittedRule = rule.split(' ')
    if (splittedRule.length !== 2) {
        return undefined
    }

    const [serializedX, serializedY] = splittedRule

    const x = deserializeUnit(serializedX, VALID_UNIT_TYPES_SET)?.value
    const y = deserializeUnit(serializedY, VALID_UNIT_TYPES_SET)?.value

    if (x === undefined || y === undefined) {
        return undefined
    }

    return {
        x,
        y
    }
}

export default {
    serialize,
    deserialize
}
